import axios from 'axios'
import { useRouter } from 'vue-router'
import { currentUserStore } from '@/stores/currentUser'
import { User } from '@/interfaces/User';
import tools from "@/composables/tools";

export default function userAuth() {    
    const router = useRouter();

    async function login(u?: string,p?: string,user_id?:number,bt?:string) : Promise<any>{
        // Limpiar espacios en blanco antes de enviar
        const cleanEmail = u ? u.trim() : u;
        const cleanPassword = p ? p.trim() : p;
        
        axios.get('login',{params:{
          email: cleanEmail,
          password: cleanPassword,
          user_id: user_id,
          bt: bt,
        }})
        .then( response => {
            localStorage.setItem('token',response.data.access_token)
            localStorage.setItem('user',JSON.stringify(response.data.user))


            //** guardamo como state los datos del usuario logeado */
            const userJson = localStorage.getItem('user');
            const currentUserObj:User = userJson !== null ? JSON.parse(userJson):{}
            const currentUser = currentUserStore()
            currentUser.update(currentUserObj)
            if(currentUserStore().$state.redirectAfterLogin !== null)
              location.href= currentUserStore().$state.redirectAfterLogin + '';
            else
              location.href='/'

        })
        .catch( (error)=>{
          return error.response.status
        })
    }

    function logout() : void {
        tools().setLog('Cerró sesión','info')
        console.log('Cerrando sesion')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        //router.push({ path: "/login" });
        location.href='login'

        //window.location.reload()
    }

    async function checkEmailTlf(email_tlf:string) : Promise<any>{
      try {
              // Limpiar espacios en blanco antes de enviar
              const cleanEmailTlf = email_tlf.trim();
              
              const response = await axios.get('checkEmailTlf',{params:{
                email: cleanEmailTlf
                }})
            return response.data  
    } catch (error) {
        tools().toast('Error en el sistema de autenticación. Consulta con el administrador #145','danger',5000)
    }

    }

    async function registerFromEntidad(email:string,pw:string,entidad_id:number) : Promise<any>{
        try {
            // Limpiar espacios en blanco antes de enviar
            const cleanEmail = email.trim();
            const cleanPassword = pw.trim();
            
            const response = await axios.get('registerFromEntidad',{params:{
              email: cleanEmail,
              pw: cleanPassword,
              entidad_id: entidad_id
              }})
          
          if(response.data.access_token !== undefined){
            localStorage.setItem('token',response.data.access_token)
            localStorage.setItem('user',JSON.stringify(response.data.user))
          
            tools().toast('Se ha creado el usuario','success',3000)
          
            const userJson = localStorage.getItem('user');
            const currentUserObj:User = userJson !== null ? JSON.parse(userJson):{}
            const currentUser = currentUserStore()
            currentUser.update(currentUserObj)
            location.href='/'
          }
          
          return response.data  
          
      } catch (error:any) {
          tools().toast('Error #146: ' + error.response.data.message,'danger',5000)
      }
      }

      function getCurrentUser(): User | null
      {
        return currentUserStore().$state.user
      }

      function isLogged(): boolean
      {
        return localStorage.getItem('token') !== null
      }

    return {login,logout,checkEmailTlf,registerFromEntidad,getCurrentUser,isLogged}
}
